export default theme => ({
  root: {
    padding: '15px 20px',
    borderColor: '#0767DB'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-between',
    justifyContent: 'space-between',
    height: 145
  },
  details: {
    display: 'flex',
    justifyContent: 'space-between',
    '&:first-child p': {
      color: 'green'
    },
    '&:nth-child(3) p': {
      color: '#da7171'
    },
    '&:nth-child(2) p': {
      color: '#0767DB'
    },
    '&:nth-child(4) p': {
      color: '#07674B'
    },
    '&:nth-child(6) p': {
      color: '#076FAB'
    },
    '&:nth-child(5) p': {
      color: '#dc3232'
    }
  },
  title: {
    color: 'black',
    fontWeight: 700,
    width: '50%',
    lineHeight: '20px',
    fontSize: 14

  },
  value: {
    width: '50%',
    textAlign: 'right',
    fontWeight: 700,
    fontSize: 14
  }
})
